export interface SearchBrowseInsideCollectionsRequest {
  branchCode: string
  placeCode: string
  searchFlag: CollectionBrowseInsideSearchFlag
  lendDate: string
  lendDateFrom: string
  lendDateTo: string
}

export const CollectionBrowseInsideSearchFlag = {
  PrefixMatch: '1',
  RangeSpecification: '2'
} as const
export type CollectionBrowseInsideSearchFlag = typeof CollectionBrowseInsideSearchFlag[keyof typeof CollectionBrowseInsideSearchFlag]

export function SearchBrowseInsideCollectionsRequestToJSON(
  value: SearchBrowseInsideCollectionsRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    place_code: value.placeCode !== '' ? value.placeCode : undefined,
    search_flag: value.searchFlag ? value.searchFlag : undefined,
    lend_date: value.lendDate !== '' ? value.lendDate : undefined,
    lend_date_from: value.lendDateFrom !== '' ? value.lendDateFrom : undefined,
    lend_date_to: value.lendDateTo !== '' ? value.lendDateTo : undefined
  }
}
